namespace GeniuzPOS.SalePromoCamp {
    export namespace PsPromoMbService {
        export const baseUrl = 'SalePromoCamp/PsPromoMb';

        export declare function Create(request: Serenity.SaveRequest<PsPromoMbRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsPromoMbRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPromoMbRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPromoMbRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "SalePromoCamp/PsPromoMb/Create",
            Update = "SalePromoCamp/PsPromoMb/Update",
            Delete = "SalePromoCamp/PsPromoMb/Delete",
            Retrieve = "SalePromoCamp/PsPromoMb/Retrieve",
            List = "SalePromoCamp/PsPromoMb/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsPromoMbService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
